import React from 'react';
import { Card, CardContent, Typography, Box } from '@material-ui/core'; // Import Box
import CountUp from 'react-countup';
import { Link } from 'react-router-dom'; // Import Link

interface CounterCardProps {
  label: string;
  count: number;
  cardClassName: string;
  shakeIt?: boolean;
  link?: string; // New prop for the link
  icon?: React.ReactNode; // New prop for the icon
}

export default function CounterCard({ label, count, cardClassName, shakeIt, link, icon }: CounterCardProps) {
  const duration = Math.min(5, Math.max(1, count / 100));
  const cardContent = (
    <Card className={`${cardClassName} ${shakeIt ? 'animate-shake' : ''}`}>
      <CardContent>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          {' '}
          {/* Use Box for layout */}
          <Typography variant="subtitle2" component="div" className="text-nowrap">
            {label.replace(/_/g, ' ')}
          </Typography>
          {icon && <Box ml={1}>{icon}</Box>} {/* Display icon */}
        </Box>
        <div className="text-right text-2xl sm:text-3xl md:text-4xl lg:text-4xl truncate">
          <CountUp end={count} duration={duration} />
        </div>
      </CardContent>
    </Card>
  );

  return link ? (
    <Link to={link} style={{ textDecoration: 'none' }}>
      {cardContent}
    </Link>
  ) : (
    cardContent
  );
}
